import { render } from "./assignmentTable.vue?vue&type=template&id=106b028f&scoped=true"
import script from "./assignmentTable.vue?vue&type=script&lang=js"
export * from "./assignmentTable.vue?vue&type=script&lang=js"

import "./assignmentTable.vue?vue&type=style&index=0&id=106b028f&lang=scss"
import "./assignmentTable.vue?vue&type=style&index=1&id=106b028f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106b028f"]])

export default __exports__